export enum LandingPageContact {
  MATCH_BY_PHONE_LINK = '8669291675',
  MATCH_BY_PHONE_DISPLAY = '866-929-1675',
}
